<template>
  <div class="inner_white" :class="{'no_pagination': noPagination}">
    <app-table-header v-if="$slots.header">
      <slot name="header" />
    </app-table-header>
    <slot name="secondary_header" />

    <form action="">
      <table class="vypis">
        <thead v-show="!hideHeader">
          <tr>
            <th class="no_padding drag_drop"></th>
            <th v-if="selectable" class="no_padding checkbox" />
            <slot></slot>
            <th class="no_padding edit" />
          </tr>
        </thead>

        <tbody v-if="loading">
          <tr>
            <td class="no_padding drag_drop"></td>
            <td :colspan="this.colspanNumber">{{ translations.loading }}</td>
            <td class="no_padding"></td>
          </tr>
        </tbody>

        <tbody v-else-if="data.length === 0">
          <tr>
            <td class="no_padding drag_drop"></td>
            <td :colspan="this.colspanNumber">{{ translations.noData }}</td>
            <td class="no_padding"></td>
          </tr>
        </tbody>

        <tbody v-else>
          <template
              v-for="(item, index) in data"
              v-if="index < pageSize"
          >
            <app-table-row
                :key="item._id"
                :name="'check-' + index"
                :row="item"
                :columns="columns"
                :clickable="clickable"
                :deletable="deletable"
                :selectable="selectable"
                :selected="selectedRows.includes(item._id)"
                :toggleable="toggleable"
                :copyable="copyable"
                :editable="editable"
                :is-opened="openedItem === item"
                :more-info="moreInfo"
                @click="rowClick(item)"
                @selectRow="$emit('rowSelect', item, $event)"
                @deleteRow="$emit('deleteRow', item)"
                @toggleRow="$emit('toggleRow', item)"
                @copyRow="copyRow(item)"
            />
            <templates-editable-row
              v-if="editable"
              :is-opened="openedItem === item"
              :item="item"
              @updatedRow="$emit('updatedRow')"
            />
            <templates-editable-row
              v-if="item === copyItem"
              :is-opened="copyItem !== null"
              :item="copyItem"
              :copy-item="true"
              @updatedRow="$emit('updatedRow')"
            />
          </template>
        </tbody>
      </table>

      <app-table-footer v-if="$slots.footer">
        <slot name="footer" />
      </app-table-footer>
    </form>

  </div>
</template>

<script>
import { getBaseOrderValue } from 'utils/helpers'
import Templates from '@/components/Show/Common/Templates'
import TemplatesEditableRow from '@/components/Templates/EditableRow'

export default {
  components: { TemplatesEditableRow, Templates },
  props: {
    data: {
      default: () => [],
      type: Object | Array
    },
    clickable: {
      type: Boolean,
      default: false
    },
    selectable: {
      type: Boolean,
      default: false
    },
    deletable: {
      type: Boolean,
      default: false
    },
    toggleable: {
      type: Boolean,
      default: false
    },
    copyable: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    hideHeader: {
      type: Boolean,
      default: false
    },
    highlightColumnsOnHover: {
      default: false,
      type: Boolean
    },
    highlightRowsOnHover: {
      default: false,
      type: Boolean
    },
    order: {
      type: String,
      default: ''
    },
    showPagination: {
      default: false,
      type: Boolean
    },
    currentPage: {
      default: 1,
      type: Number
    },
    totalPages: {
      default: 1,
      type: Number
    },
    showPageSizeSelector: {
      default: false,
      type: Boolean
    },
    availablePageSizes: {
      type: Array
    },
    pageSize: {
      type: Number,
      default: 100000
    },
    loading: {
      type: Boolean,
      default: false
    },
    selectedRows: {
      type: Array,
      default: () => []
    },
    getRowStyle: {
      type: Function,
      default: () => {}
    },
    noPagination: {
      type: Boolean,
      default: false
    },
    moreInfo: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      rows: [],
      columns: [],
      openedItem: null,
      copyItem: null
    }
  },
  computed: {
    translations() {
      return {
        loading: this.$gettext('Načítání...'),
        noData: this.$gettext('Žádné položky nebyly nalezeny')
      }
    },
    colspanNumber() {
      return this.selectable ? this.columns.length + 1 : this.columns.length
    },
    sortBy() {
      return getBaseOrderValue(this.order)
    },
    sortOrder() {
      return this.order.startsWith('-') ? 'DESC' : 'ASC'
    }
  },
  mounted() {
    // app-tableColumn elements inside app-table
    const appTableColumns = this.$slots.default
      .reduce((acc, item) => {
        return item.componentInstance
          ? [...acc, item.componentInstance]
          : acc
      }, [])

      // set column props watcher
    appTableColumns.forEach((item) => {
      Object.keys(item.$options.props).forEach(
        prop => item.$watch(prop, () => {
          this.columns = this.generateColumnsData(appTableColumns)
        })
      )
    })

    this.columns = this.generateColumnsData(appTableColumns)
  },
  methods: {
    generateColumnsData(columns) {
      return columns.map(item => ({
        ...item.$options.propsData,
        template: (item.$scopedSlots || item.$slots || {}).default
      }))
    },
    rowClick(item) {
      if (this.editable) {
        if (this.openedItem === item) {
          this.openedItem = null
        } else {
          this.openedItem = item
        }
        this.copyItem = false
      }
      this.$emit('rowClick', item)
    },
    copyRow(item) {
      this.copyItem = item
      this.openedItem = null
    }
  }
}
</script>
